import Stepper from '@eventbrite/eds-stepper';
import first from 'lodash/first';
import last from 'lodash/last';
import React, { FunctionComponent } from 'react';

export interface TicketStepperSelectorProps {
    isAppRebrandActive?: boolean;
    isCollapsedWhenMinimum?: boolean;
    isDisabled?: boolean;
    onQuantityChange: (value: number) => void;
    selectedQuantity: number;
    shouldAnimate?: boolean;
    ticketOptionsRange: number[];
    variantId: string;
}

const TicketStepperSelector: FunctionComponent<TicketStepperSelectorProps> = ({
    isAppRebrandActive,
    isCollapsedWhenMinimum,
    isDisabled,
    onQuantityChange,
    selectedQuantity,
    shouldAnimate,
    ticketOptionsRange,
    variantId,
}) => {
    const { minQuantitySelectable, minValue, maxValue } = {
        minQuantitySelectable: ticketOptionsRange[1],
        minValue: first(ticketOptionsRange) || 0,
        maxValue: last(ticketOptionsRange) || selectedQuantity,
    };

    const getStepIndexForValue = (value: number) =>
        ticketOptionsRange.indexOf(value);

    const setValueAtIndexIfValid = (newIndex: number) => {
        if (newIndex < 0 || newIndex >= ticketOptionsRange.length) {
            return;
        }

        const newValue = ticketOptionsRange[newIndex];
        onQuantityChange(newValue);
    };

    const handleOnAddTicket = () => {
        const currentIndex = getStepIndexForValue(selectedQuantity);
        const newIndex = currentIndex + 1;
        setValueAtIndexIfValid(newIndex);
    };

    const handleOnRemoveTicket = () => {
        const currentIndex = getStepIndexForValue(selectedQuantity);
        const newIndex = currentIndex - 1;
        setValueAtIndexIfValid(newIndex);
    };

    const handleOnSetQuantity = (newQuantity: number) => {
        const newIndex = getStepIndexForValue(newQuantity);
        setValueAtIndexIfValid(newIndex);
    };

    const stepperId = `ticket-stepper-selector-${variantId}`;

    return (
        <div className="eds-align--center-horizontal" data-testid={stepperId}>
            <Stepper
                minQuantitySelectable={minQuantitySelectable}
                minValue={minValue}
                maxValue={maxValue}
                totalQuantity={selectedQuantity}
                onIncreaseOneStep={handleOnAddTicket}
                onDecreaseOneStep={handleOnRemoveTicket}
                onSetQuantity={handleOnSetQuantity}
                isAppRebrandActive={isAppRebrandActive}
                isDisabled={isDisabled}
                collapsedWhenMinimum={isCollapsedWhenMinimum}
                shouldAnimate={shouldAnimate}
            />
        </div>
    );
};

export default TicketStepperSelector;
